"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateWithNullableField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class DateWithNullableField extends EditorFieldBase_1.EditorFieldBase {
}
exports.DateWithNullableField = DateWithNullableField;
